import { render, staticRenderFns } from "./Design1.vue?vue&type=template&id=6292b7e3&scoped=true"
import script from "./Design1.vue?vue&type=script&lang=js"
export * from "./Design1.vue?vue&type=script&lang=js"
import style0 from "./Design1.vue?vue&type=style&index=0&id=6292b7e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6292b7e3",
  null
  
)

export default component.exports